import React from 'react';
import PropTypes from 'prop-types';
import SaveSearchBtnContainer from '../SaveSearchBtn/SaveSearchBtnContainer';

const MobileToolbar = ({ toggleFilters, mobileFiltersActive, searchType }) => <div className="toolbar toolbar--fixed">
    { searchType ? <button
        className="facets__btn tes-btn tes-btn--primary tes-btn--block"
        type="button"
        onClick={toggleFilters}
      >
        { mobileFiltersActive ?
          <span className="facets__btn-lbl">Confirm</span> :
          <span className="facets__btn-lbl">Filters</span>
        }
    </button> :
    <div className="l-inline-container">
      <div className="l-vcenter l-vcenter--half padding-right-sm">
        <SaveSearchBtnContainer mobileToolbar={true} />
      </div>
      <div className="l-vcenter l-vcenter--half padding-left-sm">
        <button
          className="facets__btn tes-btn tes-btn--primary tes-btn--block"
          type="button"
          onClick={toggleFilters}
        >
          { mobileFiltersActive ?
            <span className="facets__btn-lbl">Confirm</span> :
            <span className="facets__btn-lbl">Filters</span>
          }
        </button>
      </div>
    </div> }
  </div>;

MobileToolbar.propTypes = {
  toggleFilters: PropTypes.func.isRequired,
  mobileFiltersActive: PropTypes.bool,
  searchType: PropTypes.bool
};

export default MobileToolbar;
